import { inject, Injectable } from '@angular/core';
import { INotification } from './notification-factory.service';
import { MessageTemplate } from '../../models/enums/enums';
import { PushNotificationService } from './push-notification.service';
import { AdditionalInformationService } from '../additional-information/additional-information.service';

@Injectable({
  providedIn: 'root'
})
export class TaskCompletedNotificationService implements INotification {
  constructor(
    private pushNotificationService: PushNotificationService,
    private additionalInfoService: AdditionalInformationService
  ) {}

  notify(message:string,data: { [key: string]: any; }): void {
    this.pushNotificationService.pushNotification(message,MessageTemplate.TaskCompleted, data);
    this.additionalInfoService.additonalInfoResponse$.next(data['additionalInformation']);
  }
}
